export default __webpack_public_path__ + "static/media/fast-delivery.f546ef40.svg";